// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2Ah48","disabled":"FileBtn_disabled__cCfd4","warn":"FileBtn_warn__390BC","fade":"FileBtn_fade__1f6DD"};